<template>
  <mobile v-if="isMobile" :playlist="playlist" :loading="loading" @open="$emit('open', $event)" />
  <client v-else :playlist="playlist" :loading="loading" @open="$emit('open', $event)" />
</template>
<script>
import { mapState, mapGetters } from 'vuex';

import Mobile from './Mobile';
import Client from './Client';

export default {
  name: 'PlaylistCard',
  components: {
    Client,
    Mobile,
  },
  computed: {
    ...mapGetters(['isMobile']),
  },
  props: ['playlist', 'loading'],
};
</script>



// WEBPACK FOOTER //
// src/components/PlaylistCard/index.vue